module.exports = __webpack_public_path__ + "static/media/test4.973370f8.jpeg";